// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.miraiapp",
    name: "Mirai App",
    homepage: "https://miraiapp.io",
    image_id: "0c8022b0-d5a3-4561-64d5-a3e60d1ed500",
    app: {
        browser: "https://miraiapp.io",
        ios: "https://apps.apple.com/vn/app/mirai-app-mpc-powered-wallet/id6472134236",
        android: "https://play.google.com/store/apps/details?id=co.mirailabs.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "miraiapp://",
        universal: "https://go.miraiapp.io",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map